import {
  FeatureAction,
  FeatureKey,
  FeaturePermission,
  useContextualFeaturePermissionQuery,
  useContextualFeaturePermissionsQuery
} from "@pathwright/graphql-client/src/generated"

export default function useLabFeatureVisibility() {
  const homeQuery = useContextualFeaturePermissionsQuery({
    variables: {
      featureKeys: { in: [FeatureKey.HomeScreenUnified] },
      featureAction: FeatureAction.HomeScreenView,
      context: null
    }
  })
  const coverPagesQuery = useContextualFeaturePermissionQuery({
    variables: {
      featureKey: FeatureKey.LibraryCoverPages,
      featureAction: FeatureAction.UpdateVisibility,
      context: null
    }
  })

  const schoolHomeCFP = homeQuery.data?.contextualFeaturePermissions?.find(
    (cfp) => !cfp.user_id && !cfp.cohort_id && !cfp.resource_id
  )

  // Keep unresolved and failed checks distinct from confirmed unavailability.
  const home =
    homeQuery.loading || homeQuery.error || !homeQuery.data
      ? null
      : schoolHomeCFP?.permission_in_context !== FeaturePermission.Everyone
  const coverPages =
    coverPagesQuery.loading || coverPagesQuery.error || !coverPagesQuery.data
      ? null
      : coverPagesQuery.data.contextualFeaturePermission
          ?.permission_in_context !== FeaturePermission.Disabled

  return {
    home,
    coverPages,
    hasAvailableLabs: home === true || coverPages === true,
    loading: homeQuery.loading || coverPagesQuery.loading,
    error: homeQuery.error || coverPagesQuery.error
  }
}
